export enum CalendlyEvent {
  DateAndTimeSelected = 'calendly.date_and_time_selected',
  EventScheduled = 'calendly.event_scheduled'
}
